import { defineStyle } from '@chakra-ui/react';
export default {
  baseStyle: defineStyle({
    color: 'CARNABY.regular',
    fontWeight: 'medium',
    _hover: {
      textDecoration: 'underline'
    },
    _focusVisible: {
      textDecoration: 'underline'
    },
    _active: {
      color: 'CARNABY.medium'
    }
  }),
  variants: defineStyle({
    homepage: {
      color: 'initial'
    },
    unstyled: {
      color: 'initial',
      fontWeight: 'initial',
      _hover: {
        color: 'initial'
      },
      _active: {
        color: 'initial'
      }
    }
  })
};